import { IspecialistDetail } from '@/store/specialist/index.d';

export const parsePriceTag = (
  { firstConsultFree, memberFree, coin, price, consultService, amount }: IspecialistDetail,
  type: number
): string => {
  if (!consultService) {
    return '';
  }

  if (memberFree) {
    return type === 1 ? '(会员免费)' : '会员免费';
  }

  if (firstConsultFree) {
    return type === 1 ? '(限时免费)' : '限时免费';
  }

  if (Number(amount) === 0) {
    return type === 1 ? '(免费)' : '免费';
  }

  return `￥${amount || price}`;
};

export const parse = () => {
  //
};

export const price = (num: number) => {
  if (!num) {
    return num;
  }
  return (num / 100).toFixed(2);
};
